import { render, staticRenderFns } from "./alertCompanySuspended.vue?vue&type=template&id=57133fea"
import script from "./alertCompanySuspended.vue?vue&type=script&lang=js"
export * from "./alertCompanySuspended.vue?vue&type=script&lang=js"
import style0 from "./alertCompanySuspended.vue?vue&type=style&index=0&id=57133fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports